import Request from '../modules/request.js'
import Notify from '../modules/notify.js'
const aivaContentId = 'aiva-content';
var currentSelected = null;

const showNotify = (data, time = false, redirect = null) => {
  if (document.getElementById('notify')) {
    document.getElementById('notify').remove();
  }
  let div = document.createElement('div');
  div.id = 'notify';
  div.className = 'notify';
  let span = document.createElement('span');
  span.innerHTML = data.message;
  div.append(span);
  document.body.append(div);
  if (time == true) {
    setTimeout(() => {
      document.getElementById('notify').remove();
    }, 3500);
  }
  if (redirect != null) {
    window.location.href = redirect;
  }
}

export default class DigitalSig {

    ShowUploadForm()
    {
        let modal = document.getElementById("modal-upload");
        modal.style.display = "block";
    }

    Apps(url)
    {
        const request = new Request();
        request.get(url, (request, response) => {
            const partial = response.data;
            const aivaContent = document.getElementById(aivaContentId);
            aivaContent.innerHTML = partial;
        });
    }

    AppsUpload(url)
    {
        console.log('Upload apk');
        const authenticity_token = document.getElementsByName('authenticity_token')[0].value;
        let form = document.getElementById('form-upload-file');
        const formData = new FormData(form);

        const data = {message: 'Aguarde', created: true}

        Pmdsl.progressView();
        fetch(form.action, {
            method: 'POST',
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            Pmdsl.progressView(100, 'Concluido');
            showNotify(data, true, data.redirect);
            window.location.reload();
        })
        .catch(error => {
            const info = {message: 'Error, check logs for details', created: true}
            showNotify(info)
            console.error('Error:', error)
            Pmdsl.progressView(98, 'Error');
            //Pmdsl.navigator('archives', data.redirect);
        });
    }

    DeviceNew(url)
    {
        const request = new Request();
        request.get(url, (request, response) => {
            const device_partial = response.data;
            const aivaContent = document.getElementById(aivaContentId);
            aivaContent.innerHTML = device_partial;
        });
    }

    DeviceEdit(url)
    {
        const request = new Request();
        request.get(url, (request, response) => {
            const device_partial = response.data;
            const aivaContent = document.getElementById(aivaContentId);
            aivaContent.innerHTML = device_partial
        });
    }

    Devices(url)
    {
        const request = new Request();
        request.get(url, (request, response) => {
            const devices_partial = response.data;
            const aivaContent = document.getElementById(aivaContentId);
            aivaContent.innerHTML = devices_partial;
        });
    }

    DeviceWifiSettings(e, url, id)
    {
        if (currentSelected != null) 
        {
            currentSelected.classList.remove("selected");
        }
        e.className = "selected";
        currentSelected = e;
        // device network settins
        const request = new Request();
        request.get(url, (request, response) => {
            const network_partial = response.data;
            const body = document.getElementById(id);
            body.innerHTML = network_partial;
            
        })
    }

    NewEthernetConfig(e, id, idhide)
    {
        if (currentSelected != null) 
        {
            currentSelected.classList.remove("selected");
        }
        e.classList.add("selected");
        currentSelected = e;
        let form = document.getElementById(id);
        form.style.display = "block";

        let formh = document.getElementById(idhide);
        formh.style.display = "none";
        
    }

    DeviceApplyEtherSetup(serial)
    {

       // pegar valores do formulario
       let ip      = document.getElementById("device_ip").value;
       let netmask = document.getElementById("device_netmask").value;
       let gateway = document.getElementById("device_gateway").value;
       let dns_primary = document.getElementById("device_dns_primary").value;
       let dns_secondary = document.getElementById("device_dns_secondary").value;
    
       let data = {
        ip: ip,
        netmask: netmask,
        gateway: gateway,
        dns_primary: dns_primary,
        dns_secondary: dns_secondary
       }

        let jsonString = JSON.stringify(data)
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.ethersetupapply(jsonString);
            }
        });
    }

    NewWlanConfig(e, id, idhide)
    {
        if (currentSelected != null) 
        {
            currentSelected.classList.remove("selected");
        }
        e.classList.add("selected");
        currentSelected = e;
        let form = document.getElementById(id);
        form.style.display = "block";

        let formh = document.getElementById(idhide);
        formh.style.display = "none";
    }

    ApplyWirelessSetup(serial)
    {
        let ssid = document.getElementById("device_ssid").value;
        let psw  =  document.getElementById("device_password").value;
        let wl = {
            ssid: ssid, 
            psw: psw
        }
        wl = JSON.stringify(wl)
        wl = JSON.parse(wl)
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.wirelesssetupapply(wl);
            }
        })

    }

    

    

    DeviceUpdateLauncher(e, url, id) {
        const request = new Request();
        request.get(url, (request, response) => {
            const partial = response.data;
            const body = document.getElementById(id);
            body.innerHTML = partial;
        })
    }

    SendUpdate(serial, url)
    {
        let jsonString = {
            url: url,
            update_launcher: true
        }
        jsonString = JSON.stringify(jsonString);
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.firmwareUpdate(jsonString);
            }
        });
    }

    DeviceRestart(e, serial)
    {
        let jsonString = {
            restart_device: true
        }
        jsonString = JSON.stringify(jsonString);
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.deviceRestart(jsonString);
            }
        });
    }
    DeviceAdbDisable(e, serial)
    {
        let jsonString = {
            disable_settings: true
        }
        jsonString = JSON.stringify(jsonString);
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.adbDisable(jsonString);
            }
        });
    }
    DeviceAdbEnable(e, serial)
    {
        let jsonString = {
            enable_settings: true
        }
        jsonString = JSON.stringify(jsonString);
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.adbEnable(jsonString);
            }
        });
    }
    DeviceTestLatency(e, serial)
    {
        let jsonString = {
            test_latency: true
        }
        jsonString = JSON.stringify(jsonString);
        jsonString = JSON.parse(jsonString);
        consumer.subscriptions.subscriptions.forEach((index) => {
            let idnt = JSON.parse(index.identifier)
            if (idnt.device == serial)
            {
                index.testLatency(jsonString);
            }
        });
    }
}